import { Component, OnInit } from "@angular/core";
import { UserService } from "../shared/service/user.service";
import { Router } from "@angular/router";
import { Userinfo } from "../../Models/Userinfo";
import { TokenService } from "../shared/service/token.service";

@Component({
  selector: "app-default",
  template: "",
})
export class DefaultComponent implements OnInit {
  constructor(
    private router: Router,
    private _userService: UserService,
    private tokenService: TokenService
  ) {}
  ngOnInit() {
    // this._userService.getJWTToken().subscribe((resData: any) => {
      // this.tokenService.saveToken(resData.Token || "");
      this._userService.getUserInformation().subscribe((userInfo: Userinfo) => {
        this.tokenService.saveToken(userInfo.Token || "");
        let info = userInfo;
        if (info.permissions != null && info.permissions.length > 0) {
          var res = info.permissions.find((per) => per.Menu == "Master");
          // if (res != null)
          //   this.router.navigateByUrl(res.URL)
          // else {
          res = info.permissions.find((per) => per.Menu == "MyProfile");
          if (res != null) {
            this.router.navigateByUrl(
              "myprofile/" + userInfo.EmpCode
            );
          }
          else {
            this.router.navigateByUrl(info.permissions[0].URL);
          }
          // }
        } else {
          this.router.navigate(["/EmployeeWithoutPermission"]);
        }
      });
    // });
  }
}
